"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaypalPurchaseItems = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function getPaypalPurchaseItems() {
    const { MAX_STRING_LENGTH: maxItemNameLength } = src_1.paypalConstants;
    const items = (0, checkout_frontend_library_1.getLineItems)();
    const fees = (0, checkout_frontend_library_1.getFees)();
    const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
    const purchaseItems = [];
    items.forEach(item => {
        const product = item.product_data;
        const qty = product.quantity.toString();
        const title = product.product_title.substring(0, maxItemNameLength - qty.length - 3);
        const description = `${product.title} - ${product.description}`;
        purchaseItems.push({
            name: `${title} x ${qty}`,
            description: description.substring(0, maxItemNameLength),
            sku: product.sku,
            quantity: qty,
            unit_amount: { currency_code: currencyCode, value: (0, src_1.getValueByCurrency)(product.price, currencyCode) },
            category: product.requires_shipping ? 'PHYSICAL_GOODS' : 'DIGITAL_GOODS',
        });
    });
    fees.forEach(fee => {
        purchaseItems.push({
            name: fee.line_text,
            description: '',
            quantity: '1',
            unit_amount: { currency_code: currencyCode, value: (0, src_1.getValueByCurrency)(fee.value, currencyCode) },
            category: 'DIGITAL_GOODS',
        });
    });
    return purchaseItems;
}
exports.getPaypalPurchaseItems = getPaypalPurchaseItems;
